export default "__VITE_ASSET__dJng3RdR__"